const SelectedIcon = ({ width = 16, height = 16, color = 'black' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6641 8.0013C14.6641 11.6832 11.6793 14.668 7.9974 14.668C4.3155 14.668 1.33073 11.6832 1.33073 8.0013C1.33073 4.3194 4.3155 1.33464 7.9974 1.33464C11.6793 1.33464 14.6641 4.3194 14.6641 8.0013Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinejoin="round"
      />
      <path
        d="M12.0334 6.17399L11.1953 5.33594L7.08739 9.44516L7.08739 10.2832L7.92544 10.2832L12.0334 6.17399Z"
        fill={color}
      />
      <path
        d="M4.83024 7.5057L3.99219 8.34375L5.93018 10.2817L6.76824 10.2817L6.76824 9.44369L4.83024 7.5057Z"
        fill={color}
      />
    </svg>
  )
}

export default SelectedIcon
